import { render, staticRenderFns } from "./updonta.vue?vue&type=template&id=ad2182b0&scoped=true&"
import script from "./updonta.vue?vue&type=script&lang=js&"
export * from "./updonta.vue?vue&type=script&lang=js&"
import style0 from "./updonta.vue?vue&type=style&index=0&id=ad2182b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2182b0",
  null
  
)

export default component.exports